import { render } from "./AeracaoPage.vue?vue&type=template&id=d1fb4d70"
import script from "./AeracaoPage.vue?vue&type=script&lang=js"
export * from "./AeracaoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__